import { Loadable } from 'foundations-components/transitional/utils/Loadable';

export const AsyncCaptureModal = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "content-media-capture" */ 'content-media-capture/CaptureModal'
    ).then((module) => module.CaptureModal),
  LoadingComponent: () => null,
});
